<template>
  <div>
    <departamento-list-add-new
      :is-add-new-departamento-sidebar-active.sync="
        isAddNewDepartamentoSidebarActive
      "
      :edit-item="editItem"
      :estado-options="statusOptions"
      :departamentos="listOfDepartamentos"
      @refetch-data="refetchData"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar por título..."
              />
              <b-button
                variant="primary"
                @click="isAddNewDepartamentoSidebarActive = true"
              >
                <span class="text-nowrap">Crear Departamento</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refDepartamentoListTable"
        class="position-relative"
        :items="fetchDepartamentos"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros coincidentes"
        :sort-desc.sync="isSortDirDesc"
        :busy="!fetchDepartamentos"
      >
        <!-- Table Loading -->
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner
              class="align-middle"
              small
            />
            <strong class="ml-1">Cargando datos...</strong>
          </div>
        </template>

        <!-- Column: Id -->
        <template #cell(id)="data">
          <b-link
            class="font-weight-bold d-block text-nowrap"
            @click="
              isAddNewDepartamentoSidebarActive = true;
              editItem = data.item;
            "
          >
            #{{ data.item.id }}
          </b-link>
        </template>

        <!-- Column: Description -->
        <template #cell(descripcion)="data">
          <span>
            {{ data.item.descripcion || "-" }}
          </span>
        </template>

        <!-- Column: Estado -->
        <template #cell(estado)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.estado)}`"
            class="text-capitalize"
          >
            {{ resolveStatusText(data.item.estado) }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-row align-h="center">
            <b-button
              :id="`edit-${data.item.id}`"
              class="mr-1 btn-icon"
              variant="success"
              @click="
                isAddNewDepartamentoSidebarActive = true;
                editItem = data.item;"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-tooltip
              :target="`edit-${data.item.id}`"
              triggers="hover"
              placement="bottom"
              boundary="window"
            >
              <b>Editar</b>
            </b-tooltip>

            <b-button
              v-if="data.item.num_empleados < 1"
              :id="`delete-${data.item.id}`"
              class="mr-1 btn-icon"
              variant="danger"
              @click="deleteDepartamento(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
            <b-tooltip
              :target="`delete-${data.item.id}`"
              triggers="hover"
              placement="bottom"
              boundary="window"
            >
              <b>Eliminar</b>
            </b-tooltip>
            <!-- <b-link>
              <feather-icon icon="TrashIcon" />
              </b-link> -->
          </b-row>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span
              class="text-muted"
            >Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de
              {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalDepartamentos"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BPagination,
  BSpinner,
  BTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useDepartamentosList from './useDepartamentosList'
import useQuerySync from '@/utils/useQuerySync'
import departamentoStoreModule from './departamentoStoreModule'
import DepartamentoListAddNew from './DepartamentoListAddNew.vue'

export default {
  components: {
    DepartamentoListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BPagination,
    BSpinner,
    BTooltip,

    vSelect,
  },
  async mounted() {
    this.listOfDepartamentos = await this.listDepartamentos()
  },
  methods: {
    deleteDepartamento(id) {
      this.$store.dispatch('app-departamento/deleteDepartamento', id).then(() => {
        this.deleteModal = false
        this.refetchData()
      })
    },
  },
  setup() {
    const DEPARTAMENTO_APP_STORE_MODULE_NAME = 'app-departamento'

    // Register module
    if (!store.hasModule(DEPARTAMENTO_APP_STORE_MODULE_NAME)) {
      store.registerModule(
        DEPARTAMENTO_APP_STORE_MODULE_NAME,
        departamentoStoreModule,
      )
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DEPARTAMENTO_APP_STORE_MODULE_NAME)) store.unregisterModule(DEPARTAMENTO_APP_STORE_MODULE_NAME)
    })

    const isAddNewDepartamentoSidebarActive = ref(false)
    const editItem = ref(null)
    const deleteItem = ref(null)

    const statusOptions = [
      { label: 'inactivo', value: '0' },
      { label: 'activo', value: '1' },
      { label: 'pendiente', value: '2' },
    ]

    const {
      fetchDepartamentos,
      listDepartamentos,
      tableColumns,
      perPage,
      currentPage,
      totalDepartamentos,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDepartamentoListTable,
      refetchData,
      deleteData,

      // UI
      resolveStatusVariant,
      resolveStatusText,
      parseDate,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useDepartamentosList()

    useQuerySync({
      search: searchQuery,
      page: currentPage,
      per_page: perPage,
    })

    const listOfDepartamentos = []
    return {
      // Sidebar
      isAddNewDepartamentoSidebarActive,
      editItem,
      deleteItem,

      fetchDepartamentos,
      listDepartamentos,
      listOfDepartamentos,
      tableColumns,
      perPage,
      currentPage,
      totalDepartamentos,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDepartamentoListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveStatusVariant,
      resolveStatusText,
      parseDate,

      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
